export default import.meta.ROLLUP_FILE_URL_H9ut1yvdyfugr_ESs8Ccnw